/**
 * Lot Matching Method Enumeration
 *
 * Defines the algorithm used to select which lots are sold:
 * - FIFO: First-In-First-Out (oldest lots sold first)
 * - LIFO: Last-In-First-Out (newest lots sold first)
 * - HIFO: Highest-In-First-Out (highest cost basis lots sold first)
 * - SpecificLot: User manually selects which specific lots to sell
 */
export enum LotMatchingMethod {
  FIFO = 'fifo',
  LIFO = 'lifo',
  HIFO = 'hifo',
  SpecificLot = 'specific_lot',
  /** Average cost method (typically for mutual funds) */
  Average = 'average',
}
